import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, nextTick, ref, reactive, onActivated, watch } from "vue";
import { useStore } from "vuex";
import List from "./components/List.vue";
export default defineComponent({
  name: "Democracy",
  components: {
    Head: Head,
    Pagination: Pagination,
    Tabs: Tabs,
    List: List
  },
  setup: function setup() {
    var user = useStore().state.user.user.userId; //获取用户id

    var issecretary = ref(0);
    var isactive = ref(0);
    var titles = ref(["我的评议", "评议人评议"]);

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var table1 = ref();
    var table2 = ref();
    var Data = reactive({
      titleArr: ["待评议", "历史记录"],
      topTabsIndex: 0,
      tabsIndex: 0,
      totalNum: 0
    });

    function isuser() {
      return _isuser.apply(this, arguments);
    }

    function _isuser() {
      _isuser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["isuser"]();

              case 2:
                res = _context.sent;
                issecretary.value = res;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _isuser.apply(this, arguments);
    }

    isuser(); // 身份切换

    function titlechange(val) {
      isactive.value = val;
      Data.topTabsIndex = val;
    } //tab切换


    function tabchange(val) {
      Data.tabsIndex = val;
    } // 获取详情


    function getList() {
      nextTick(function () {
        if (Data.tabsIndex == 0) {
          table1.value.getTabledata();
        } else {
          table2.value.getTabledata();
        }
      });
    } // 监听tabs索引值改变


    watch(function () {
      return Data.tabsIndex;
    }, function (val) {
      if (val == 0) {
        table1.value.initData();
      } else {
        table2.value.initData();
      }
    });
    getList(); // pager分页改变

    watch(function () {
      return Data.topTabsIndex;
    }, function () {
      getList();
    }); //刷新列表

    onActivated(function () {
      getList();
    });
    return {
      table1: table1,
      table2: table2,
      Data: Data,
      // 用户id
      user: user,
      // 身份名称
      titles: titles,
      //选中样式标示
      isactive: isactive,
      //状态切换
      tabchange: tabchange,
      //身份切换
      titlechange: titlechange,
      //是否为书记的标识
      issecretary: issecretary
    };
  }
});